import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { DateTimePicker } from "orion-components/CBComponents";
import dateTimePickerTheme from "../../shared/theme/dateTimePickerTheme";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

const propTypes = {
	handleSelect: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.any,
	disabled: PropTypes.bool,
	timeFormat: PropTypes.string,
	dir: PropTypes.string
};

const ScheduleField = ({ handleSelect, value, label, disabled, timeFormat, dir }) => {
	const format = `full_${timeFormat}`;

	return (
		<Fragment>
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={dateTimePickerTheme}>
					<DateTimePicker
						id="eta"
						label={label}
						value={value}
						handleChange={handleSelect}
						disabled={disabled}
						format={format}
						dir={dir}
						clearable={true}
						theme="light"
					/>
				</ThemeProvider>
			</StyledEngineProvider>
		</Fragment>
	);
};

ScheduleField.propTypes = propTypes;

export default ScheduleField;
